import React from 'react';
import './App.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { AgentProvider } from './contexts/AgentContext';
import { AdminProvider } from './contexts/AdminContext';
import { PlatformProvider } from './contexts/PlatformContext';
import ProtectedRoute from './components/ProtectedRoute';
import AgentRoute from './components/AgentRoute';
import AdminRoute from './components/AdminRoute';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import GetQuote from './pages/GetQuote';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import MakeClaim from './pages/MakeClaim';
import ClaimDetail from './pages/ClaimDetail';
import TrackEngineer from './pages/TrackEngineer';
import Triage from './pages/Triage';
import About from './pages/About';
import Contact from './pages/Contact';
import Help from './pages/Help';
import ApplianceCover from './pages/ApplianceCover';
import HomeEmergency from './pages/HomeEmergency';
import BoilerCover from './pages/BoilerCover';
import BlogPost from './pages/BlogPost';
import AgentLogin from './pages/agent/AgentLogin';
import AgentDashboard from './pages/agent/AgentDashboard';
import NewPolicy from './pages/agent/NewPolicy';
import PolicyDetail from './pages/agent/PolicyDetail';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import TermsPage from './pages/legal/TermsPage';
import PrivacyPage from './pages/legal/PrivacyPage';
import RefundPolicy from './pages/legal/RefundPolicy';
import CancellationPolicy from './pages/legal/CancellationPolicy';
import ComplaintsProcedure from './pages/legal/ComplaintsProcedure';
import CompliancePolicy from './pages/legal/CompliancePolicy';
import VulnerableCustomerPolicy from './pages/legal/VulnerableCustomerPolicy';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AdminProvider>
          <AuthProvider>
            <PlatformProvider>
              <DataProvider>
                <AgentProvider>
                  <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/quote" element={<GetQuote />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/help" element={<Help />} />
                      <Route path="/triage" element={<Triage />} />
                      <Route path="/appliance-cover" element={<ApplianceCover />} />
                      <Route path="/home-emergency" element={<HomeEmergency />} />
                      <Route path="/boiler-cover" element={<BoilerCover />} />
                      <Route path="/blog/:slug" element={<BlogPost />} />
                      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                      <Route path="/dashboard/new" element={<ProtectedRoute><MakeClaim /></ProtectedRoute>} />
                      <Route path="/dashboard/claim/:id" element={<ProtectedRoute><ClaimDetail /></ProtectedRoute>} />
                      <Route path="/dashboard/track/:id" element={<ProtectedRoute><TrackEngineer /></ProtectedRoute>} />
                      <Route path="/agent/login" element={<AgentLogin />} />
                      <Route path="/agent" element={<AgentRoute><AgentDashboard /></AgentRoute>} />
                      <Route path="/agent/new" element={<AgentRoute><NewPolicy /></AgentRoute>} />
                      <Route path="/agent/policy/:id" element={<AgentRoute><PolicyDetail /></AgentRoute>} />
                      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                      <Route path="/admin/login" element={<AdminLogin />} />
                      <Route path="/legal/terms" element={<TermsPage />} />
                      <Route path="/legal/privacy" element={<PrivacyPage />} />
                      <Route path="/legal/refund-policy" element={<RefundPolicy />} />
                      <Route path="/legal/cancellation-policy" element={<CancellationPolicy />} />
                      <Route path="/legal/complaints" element={<ComplaintsProcedure />} />
                      <Route path="/legal/compliance" element={<CompliancePolicy />} />
                      <Route path="/legal/vulnerable-customer" element={<VulnerableCustomerPolicy />} />
                    </Routes>
                  </BrowserRouter>
                  <Toaster />
                </AgentProvider>
              </DataProvider>
            </PlatformProvider>
          </AuthProvider>
        </AdminProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
